import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    // Don't auto-open if Up Cart Drawer is installed (it handles drawer opening)
    const upCartInstalled = document.querySelector('[data-upcart-drawer], .upcart-drawer, #upcart-drawer') ||
                           window.upcart ||
                           document.querySelector('script[src*="upcart"]');

    if (upCartInstalled) {
      console.log('Up Cart Drawer detected - skipping theme cart drawer auto-open');
      return;
    }

    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  // open() {
  //   this.showDialog();

  //   /**
  //    * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
  //    */
  //   customElements.whenDefined('shopify-payment-terms').then(() => {
  //     const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
  //     const cta = installmentsContent?.querySelector('#shopify-installments-cta');
  //     cta?.addEventListener('click', this.closeDialog, { once: true });
  //   });
  // }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
